import { render, staticRenderFns } from "./project_home.vue?vue&type=template&id=4b93042a&scoped=true"
import script from "./project_home.vue?vue&type=script&lang=js"
export * from "./project_home.vue?vue&type=script&lang=js"
import style0 from "./project_home.vue?vue&type=style&index=0&id=4b93042a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b93042a",
  null
  
)

export default component.exports